var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('section',{staticClass:"main-layout"},[_c('sidebar',{attrs:{"menu":_vm.menu}}),_c('div',{staticClass:"section"},[_c('breadcrumb'),_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }